export const environment = {
  production: true,
  embedded_vasat:true
};
